const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { MediaUpload, InspectorControls } = wp.blockEditor;
const { useSelect } = wp.data;
const {
	Button,
	TextControl,
	Panel,
	PanelBody,
	PanelRow,
	Icon,
	ColorPalette,
	ButtonGroup,
	SelectControl,
	ComboboxControl,
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;
import { useState } from "react";

const { __experimentalLinkControlSearchInput: LinkControlSearchInput } =
	wp.blockEditor;

registerBlockType(
	"qteblocks/product-external", // Name of the block with a required name space
	{
		title: "Produkt (Affiliate länk)",
		description: "Visa en produkt från en annan hemsida. Du anger text, bild och url själv.",
		icon: "products", // Icon, from WP icons
		category: "qteblocks",

		attributes: {
			title: {
				type: "string",
				default: "",
			},
			image: {
				type: "string",
				default: "",
			},
			price: {
				type: "string",
				default: "",
			},
			url: {
				type: "string",
				default: "",
			},
			buttonText: {
				type: "string",
				default: "Köp nu",
			}
		},

		edit(props) {
			var attributes = props.attributes;

			return (
				<>
					<InspectorControls>
						<Panel>
							<PanelBody
								title="Inställningar"
								icon={<Icon icon="admin-generic" />}
								initialOpen={true}
							>
								<PanelRow>
									<TextControl
										label="Titel"
										value={attributes.title}
										onChange={(title) => {
											props.setAttributes({ title: title });
										}}
									/>
								</PanelRow>

								<PanelRow>
									<MediaUpload
											label='Bild'
											onSelect={(media) => {
												props.setAttributes({
													image: media.url,
												});
											}}
											type="image"
											value={attributes.image}
											render={({ open }) => (
												<div>
													{ attributes.image == "" && <Button variant="secondary" onClick={ open }>Ladda upp bild</Button> }

													{ attributes.image &&
														<>
															<Button variant="link" onClick={ open }>
																<img src={ attributes.image } />
															</Button>
															<Button variant="secondary" onClick={ () => props.setAttributes({ image: "" }) }>Ta bort bild</Button>
														</>
													}
												</div>
											)}>
										</MediaUpload>
								</PanelRow>

								<PanelRow>
									<TextControl
										label="Pris"
										value={attributes.price}
										onChange={(price) => {
											props.setAttributes({ price: price });
										}}
									/>
								</PanelRow>

								<PanelRow>
									<TextControl
										label="URL"
										value={attributes.url}
										onChange={(url) => {
											props.setAttributes({ url: url });
										}}
									/>
								</PanelRow>

								<PanelRow>
									<TextControl
										label="Knapp-text"
										value={attributes.buttonText}
										onChange={(buttonText) => {
											props.setAttributes({ buttonText: buttonText });
										}}
									/>
								</PanelRow>
									
							</PanelBody>
						</Panel>
					</InspectorControls>
					<ServerSideRender
						block="qteblocks/product-external"
						attributes={props.attributes}
					/>
				</>
			);
		},

		save(props) {
			return null; // See PHP side. This block is rendered on PHP.
		},
	},
);
